import { render, staticRenderFns } from "./SupplierElement.vue?vue&type=template&id=50b95ebb&scoped=true"
import script from "./SupplierElement.vue?vue&type=script&lang=js"
export * from "./SupplierElement.vue?vue&type=script&lang=js"
import style0 from "./SupplierElement.vue?vue&type=style&index=0&id=50b95ebb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b95ebb",
  null
  
)

export default component.exports